import React, { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton, DeleteButton } from "../../../../containers/UI/Modal/BaseModal";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import FileRow from "../../../configuration/shared/FileRow/FileRow";
import axios from "../../../../axios";


class SoftwareModal extends Component {

  state = {
    chosenFile: null,
    selectedFileName: null,
  }

  componentDidMount() {
    this.setState({ ...this.props.selectedSoftware })
  }

  saveSoftwareToServer = () => {

    if (this.state.chosenFile === null && this.props.addMode) {
      alert("Please upload a file.")
      return;
    }

    // Handle file upload in both add mode and when replacing file in edit mode
    if (this.state.chosenFile !== null) {

      // Upload the file
      // Read the file's contents
      let version = this.state.versionNumber
      let thisRef = this
      let reader = new FileReader();
      reader.addEventListener("load", function() {

        // Process result
        let packageContents = reader.result.split("base64,")[1];

        // Upload the base64-encoded contents to the backend
        axios.post("/decoders/uploadDeb", { dpkgPackage: packageContents, fileName: "allorado-decoders-" + version + ".deb" })
        .then(() => {
          
          // Update entry in DB
          axios.post("/decoders/updateVersion", thisRef.state);
          
          // Close the modal
          thisRef.props.closeModal()

        }).catch(err => {
          let message = err.toString()
          if (err.response) {
            if (typeof err.response.data === "object") {
              message = message + "\r\n" + JSON.stringify(err.response.data)
            }
          }
          alert(message)
        })

      }, false)
      reader.readAsDataURL(this.state.chosenFile)

    } else if (this.state.modified) {
      // No file selected but other fields were modified
      axios.post("/decoders/updateVersion", this.state);
      this.props.closeModal()
    } else {
      this.props.closeModal()
    }
  }

  deleteVersionHandler = () => {

    let identifier = this.props.selectedSoftware._id
    let version = this.props.selectedSoftware.versionNumber

    axios.delete("/decoders/deleteVersion/" + identifier + "/" + version)
    .then(() => {
              
      // Close the modal
      this.props.closeModal()

    }).catch(err => {
      let message = err.toString()
      if (err.response) {
        if (typeof err.response.data === "object") {
          message = message + "\r\n" + JSON.stringify(err.response.data)
        }
      }
      alert(message)
    })
  }

  uploadFile = (event) => {
    const file = event.target.files[0]
    if (!file) return
    this.setState({ 
      chosenFile: file,
      selectedFileName: file.name,
      modified: true
    })
  }


  render() {

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title={this.props.addMode ? "Add decoder version" : "Edit decoder version"}
      >
        <InputRow
          title="Software component"
          enabled={false}
          ultrawide
          firstRow
          value={this.state.softwareComponent ?? ""}/>
        <InputRow
          title="Version number"
          enabled
          ultrawide
          value={this.state.versionNumber ?? ""}
          placeholder={"E.g. 1.0.2"}
          onChange={(event) => this.setState({ versionNumber: event.target.value, modified: true })}/>
        <InputRow
          title="Release date"
          enabled
          ultrawide
          value={this.state.releaseDate ?? ""}
          placeholder={"E.g. January 14th 2022"}
          onChange={(event) => this.setState({ releaseDate: event.target.value, modified: true })}/>
        <InputRow
          title="Update description"
          enabled
          ultrawide
          value={this.state.changelogMessage ?? ""}
          placeholder={"Changelog message"}
          onChange={(event) => this.setState({ changelogMessage: event.target.value, modified: true })}/>

          <FileRow
            title={this.props.addMode ? "Decoder package" : "Replace package"}
            body={this.props.addMode ? "Upload .deb file" : "Replace .deb file"}
            inputId="decoderPackageInput"
            selectedFileName={this.state.selectedFileName}
            extension=".deb"
            onClick={this.uploadFile}/>

        <ModalActions>
          {this.state.modified ? (
            <>
              <CancelButton onClick={this.props.closeModal}/>
              {!this.props.addMode && <DeleteButton onClick={this.deleteVersionHandler}/>}
              <SaveButton onClick={this.saveSoftwareToServer}>
                {this.props.addMode ? "Upload" : "Update"}
              </SaveButton>
            </>
          ) : (
            <>
              <CancelButton onClick={this.props.closeModal}>Close</CancelButton>
              {!this.props.addMode && <DeleteButton onClick={this.deleteVersionHandler}/>}
            </>
          )}
        </ModalActions>
      </BaseModal>
    );
  }
}

export default SoftwareModal;
